import { render } from "./gameLink.vue?vue&type=template&id=596a6efe&scoped=true"
import script from "./gameLink.vue?vue&type=script&lang=js"
export * from "./gameLink.vue?vue&type=script&lang=js"

import "./gameLink.vue?vue&type=style&index=0&id=596a6efe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596a6efe"]])

export default __exports__